import { type Address } from "@repo/api";
import { type FC } from "react";
import { countryCode2CountryName } from "../../utils";

export const indicateStarPensionEmptyAddress = (address: { zip?: string | null }): boolean => {
    if (address.zip === "00000") return true;
    return false;
};

const AddressTemplate: FC<{
    address: (Omit<Address, "type" | "zip"> & { zip?: string | null }) | undefined;
}> = ({ address }) => {
    if (!address || Object.keys(address).length === 0) {
        return <>-</>;
    }
    return (
        <>
            {address.street ?? ""} {address.houseNumber ?? ""}
            <br />
            {address.zip && !indicateStarPensionEmptyAddress(address) ? address.zip : ""} {address.town ?? ""}
            <br />
            {address.country && !indicateStarPensionEmptyAddress(address)
                ? countryCode2CountryName(address.country)
                : ""}
        </>
    );
};

export default AddressTemplate;
